import { Avatar, Divider } from '@mui/material'
import { formatLongNumber } from 'utils/number'
import React from 'react'
import { Colors } from 'constants/colors'
import FavoriteIcon from '@mui/icons-material/Favorite'
import ChatBubbleIcon from '@mui/icons-material/ChatBubble'
import SocialMediaIcon from 'components/SocialMediaIcon/SocialMediaIcon'

interface CreatorCardProps {
  username: string | undefined | null
  followersCount: number | undefined | null
  hashtags: Array<string | null> | undefined
  likesCount: number | undefined | null
  commentsCount: number | undefined | null
  avatarUrl: string | undefined | null
  summary: string | undefined | null
  relatedProfiles: Array<string | null> | undefined
}

export default function CreatorCard(props: CreatorCardProps): JSX.Element {
  const {
    username,
    followersCount,
    hashtags,
    likesCount,
    commentsCount,
    avatarUrl,
    summary,
    relatedProfiles,
  } = props
  const defaultImage =
    'https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg'
  return (
    <div
      style={{
        backgroundColor: Colors.backgroundDark,
        borderRadius: '10px',
        padding: '30px 20px',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <a
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            cursor: 'pointer',
            textDecoration: 'none',
            color: '#fff',
          }}
          href={`https://www.instagram.com/${username ?? ''}`}
          target="_blank"
          rel="noreferrer"
        >
          <Avatar src={avatarUrl ?? defaultImage} />
          <h4>@{username}</h4>
        </a>
        <span
          style={{
            fontWeight: 700,
            color: '#fff',
          }}
        >
          {formatLongNumber(followersCount ?? 0)}
        </span>
      </div>
      <div style={{ lineHeight: 1.1 }}>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '5px' }}>
          <FavoriteIcon
            sx={{
              color: Colors.pink,
              fontSize: '18px',
            }}
          />

          <p
            style={{
              color: Colors.buttonBlue,
              fontWeight: 700,
              marginBottom: 0,
            }}
          >
            {likesCount}
          </p>
        </div>
        <span style={{ color: Colors.darkGray, fontSize: '12px' }}>
          Average amount of likes per post
        </span>
      </div>
      <div style={{ lineHeight: 1.1 }}>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '5px' }}>
          <ChatBubbleIcon
            sx={{
              color: Colors.darkLightGray,
              fontSize: '18px',
            }}
          />
          <p
            style={{
              color: Colors.buttonBlue,
              fontWeight: 700,
              marginBottom: 0,
            }}
          >
            {commentsCount}
          </p>
        </div>
        <span style={{ color: Colors.darkGray, fontSize: '12px' }}>
          Average amount of comments per post
        </span>
      </div>
      {summary && (
        <div>
          <p
            style={{
              color: Colors.darkDeepGray,
              fontWeight: 700,
              fontSize: '13px',
              paddingLeft: '15px',
              margin: '20px 0',
              height: '50px',
            }}
          >
            <i>{summary}</i>
          </p>
        </div>
      )}
      {/* Hashtags */}
      <div style={{ marginTop: '20px' }}>
        {hashtags?.length ? (
          hashtags.map((hashtag, index) => {
            return (
              <div key={`${hashtag ?? ''}-${index}`}>
                <p style={{ fontWeight: 700, color: '#E0E0E0' }}>#{hashtag}</p>
                {index !== hashtags.length - 1 && (
                  <Divider sx={{ backgroundColor: '#333' }} />
                )}
              </div>
            )
          })
        ) : (
          <p style={{ color: '#B0B0B0' }}>There is no hashtags</p>
        )}
      </div>
      {/* Releted Profiles */}
      <div>
        <h4 style={{ margin: '30px 0 10px 0', color: Colors.darkCoolGray }}>
          Related profiles
        </h4>
        {relatedProfiles?.length ? (
          relatedProfiles.map((profile, index) => {
            return (
              <div key={profile}>
                <a
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    color: '#fff',
                    padding: '10px 0',
                  }}
                  href={`https://www.instagram.com/${profile ?? ''}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <SocialMediaIcon platformName="Instagram" width={22} />
                  <span
                    style={{
                      fontWeight: '700',
                    }}
                  >
                    {profile}
                  </span>
                </a>
                {index !== relatedProfiles.length - 1 && (
                  <Divider sx={{ backgroundColor: '#333' }} />
                )}
              </div>
            )
          })
        ) : (
          <p style={{ color: '#B0B0B0' }}>
            <i>We couldn&apos;t find any related profiles</i>
          </p>
        )}
      </div>
    </div>
  )
}
